<nb-card [nbSpinner]="!this.isLoaded">
  <nb-card-header>
    <h3 class="col">User Select</h3>
  </nb-card-header>

  <nb-card-body>
    <div class="col" style="overflow-y: scroll;">
      <div class="m-scrollable m-scroller" style="height: 40vh;">
        <mat-list dense>
          <mat-list-item *ngFor="let user of this.userList">
            <mat-checkbox [checked]="user.selected" (change)="onUserSelect($event, user)">{{user.name}}</mat-checkbox>

          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer class="row" style="margin-top: 10px;">

    <div class="col-md-auto d-flex align-items-center" >
      <button mat-raised-button color="primary" (click)="saveAndClose()">Save and
        Close</button>
    </div>
    <div class="col d-flex align-items-center justify-content-start">
      <a mat-button (click)="close()">Cancel</a>
    </div>
    <div class="col d-flex align-items-center justify-content-end">
      Users selected: {{selectedUserList.length}}
    </div>
  </nb-card-footer>

</nb-card>